exports = module.exports = require("../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-field-variable-switcher{cursor:pointer;opacity:.6;margin-left:2px}.engine-field-variable-switcher.engine-active{opacity:1;background:var(--color-brand,#006cff);color:#fff!important;border-radius:3px;margin-left:4px}.engine-field-variable-switcher.engine-active svg{height:22px!important;width:22px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/fields/variableSwitcher.less
// module id = 279
// module chunks = 0